export default "__VITE_ASSET__Ddw7fNaU__"